module.exports = __webpack_public_path__ + "img/rolled-up-newspaper.466d074c.png";